import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/i18n/useI18n'

interface RouteErrorBoundaryProps {
  error?: unknown
  reset?: () => void
}

export function RouteErrorBoundary({ error, reset }: RouteErrorBoundaryProps) {
  const { t } = useI18n()
  const message =
    error instanceof Error ? error.message : t('common.unexpectedError')

  return (
    <div className="space-y-4 p-6">
      <Alert variant="destructive">
        <AlertTitle>{t('common.unexpectedErrorTitle')}</AlertTitle>
        <AlertDescription>{message}</AlertDescription>
      </Alert>
      {reset && (
        <Button onClick={reset} variant="outline">
          {t('common.retry')}
        </Button>
      )}
    </div>
  )
}
